const BotonesOpciones = ({
	HandlerNuevoCliente,
	animar,
	HandlerBusquedaClientes,
	HandlerBusquedaCompleta,
}) => {
	return (
		<div className={`row divGenerador ${animar && "animar"}`}>
			<div className='columns small-12 callout' style={{ margin: "0px", padding: "0px" }}>
				<div className='columns small-4'>Opciones:</div>
				<div className='columns small-8'>Listados Filtrados de Clientes:</div>
				&nbsp;
				<div className='columns small-12'>
					<div className='columns small-4'>
						<a
							className='success button'
							onClick={(e) => HandlerNuevoCliente(e)}
						>
							Agregar Cliente Nuevo
						</a>
					</div>
					<div className='columns small-2'>
						<a
							className='button'
							id='Vigente'
							onClick={(e) => HandlerBusquedaCompleta(e)}
						>
							Vigentes
						</a>
					</div>
					<div className='columns small-4'>
						<a
							className='button alert'
							id='Todo'
							onClick={(e) => HandlerBusquedaCompleta(e)}
						>
							Mostrar Todos los Clientes
						</a>
					</div>
					<div className='columns small-2'>&nbsp;</div>
					<div className='columns small-4'>&nbsp;</div>
					<div className='columns small-8'>
						<div class="button-group">
							<a
								className='button'
								id='No Vigente'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								No Vigentes
							</a>
							<a
								className='button'
								id='Con Deuda'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Con Deuda
							</a>
							<a
								className='button'
								id='Sin Deuda'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Sin Deuda
							</a>
						
							<a
								className='button'
								id='Con Patente'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Con Patente
							</a>
							<a
								className='button'
								id='Sin Patente'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Sin Patente
							</a>
							<a
								className='button'
								id='Con DICOM'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Con DICOM
							</a>
							<a
								className='button'
								id='Sin DICOM'
								onClick={(e) => HandlerBusquedaCompleta(e)}
							>
								Sin DICOM
							</a>	
						</div>	
					</div>
				</div>
			</div>
			&nbsp;
			<div className='columns small-12 callout'>
				<div className='columns small-12'>También Puedes:</div>
				&nbsp;
				<div className='columns small-12'>
					<a
						className='warning button expanded'
						onClick={(e) => HandlerBusquedaClientes(e)}
					>
						Realizar Busqueda de Clientes
					</a>
				</div>
			</div>
		</div>
	);
};

export default BotonesOpciones;
